import {TextAnchorProperty} from 'csstype';
import * as d3 from 'd3';

import {Strand} from 'constants/MolbioConstants';
import arcs from 'molbio/maps/circular/Arcs';
import {SegmentsRingData} from 'molbio/maps/circular/CircularTypedefs';
import * as mapsutil from 'molbio/maps/MapsUtil';
import {Point} from 'util/geometry/GeometryConstants';
import {getAngle, polarToCartesian} from 'util/geometry/GeometryUtil';

/**
 * Gets the cartesian point on a circle representing a sequence given the position on the sequence.
 * @param circleCenter Cartesian point of the circle center
 * @param index Zero-indexed position of the point to find on the sequence
 * @param length Length represented by the entire circle
 * @param radius Radius of the circle
 */
export function getCirclePoint(circleCenter: Point, index: number, length: number, radius: number): Point {
  return polarToCartesian(circleCenter, radius, getAngle(index, length));
}

/**
 * Gets the text anchor for text rendered at a point on a circle.
 */
export function getTextAnchorForCircularText(circleCenter: Point, textPoint: Point): TextAnchorProperty {
  if (textPoint.x > circleCenter.x) {
    return 'start';
  } else {
    return 'end';
  }
}

/**
 * Gets the arc function for drawing a feature of the given strand.
 */
export function getArcForStrand(strand: Strand): d3.Arc<unknown, d3.DefaultArcObject> {
  switch (strand) {
    case 0:
      return d3.arc();
    case -1:
      return arcs.backwardArc();
    case 1:
    default:
      return arcs.forwardArc();
  }
}

/**
 * Given data for a segmented ring view, compute the minimum number of rings that that view needs
 */
export function getMinRings(data: Array<SegmentsRingData>, visible: boolean): number {
  if (!visible) {
    return 0;
  }

  const maxLayer = mapsutil.getMax(data);
  if (Number.isNaN(maxLayer)) {
    return 0;
  }
  return maxLayer + 1;
}
